import { DecorationType, SpotType } from '@spiaggeit/spit-core'
import { t } from 'i18next'
import { LicenseBookingMode } from '@/models/license'
import { licenseSlice } from '@/store/licenseSlice'
import { mapSelectors } from '@/store/mapSlice'
import { mappedSpotTypes } from '@/utils/constants'
import { useAppSelector } from './store'

//When the user is choosing their reservation spot through sector view instead of map,
//we do not show the spot name, but only the spot type + sector name
//E.g.: "Umbrella 11" becomes "Umbrella - Settore 1° fila"

export const useMapSpotName = () => {
  const license = useAppSelector(licenseSlice.selectors.license)
  const bookingMode = license?.bookingMode
  const sectors = useAppSelector(mapSelectors.sectors)

  const getMapSpotName = (
    spot?: {
      sectorName?: string
      sectorId?: number
      name: string
      subType: SpotType | DecorationType // FIXME: this should only need SpotType
    } | null,
    config?: { shouldShowSpotName?: boolean }
  ) => {
    if (!spot || !spot.subType) return t('common.tickets')

    const translatedSpotType = spot.subType
      ? t(mappedSpotTypes[spot.subType].label)
      : ''

    let visibleName: string = ''

    const spotName = spot.name
    const sector = sectors.find((sector) => sector.header.id === spot.sectorId)
    const sectorName = sector?.header.name ?? spot.sectorName
    if (config) {
      visibleName = (config.shouldShowSpotName ? spotName : sectorName) ?? ''
    } else {
      visibleName =
        (bookingMode === LicenseBookingMode.SECTORS ? sectorName : spotName) ??
        ''
    }

    return `${translatedSpotType} ${visibleName}`
  }
  return { getMapSpotName }
}
